module.exports = __webpack_public_path__ + "img/8-diamond.2a5cbd7c.png";